"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createClient = void 0;
var axios_1 = __importDefault(require("axios"));
var create_http_client_1 = __importDefault(require("./create-http-client"));
var create_api_1 = require("./create-api");
var createClient = function createClient(options) {
  if (!options.apiKey) {
    throw new TypeError('Expected parameter apiKey');
  }
  if (!options.apiUrl) {
    throw new TypeError('Expected parameter apiUrl');
  }
  if (!options.siteId) {
    throw new TypeError('Expected parameter siteId');
  }
  var opts = __assign(__assign({}, options), {
    preview: options.preview || false
  });
  var http = create_http_client_1.default({
    axios: axios_1.default,
    options: opts
  });
  return create_api_1.createApi({
    http: http,
    options: options
  });
};
exports.createClient = createClient;
__exportStar(require("./types/index"), exports);